import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Accordion from 'react-bootstrap/Accordion';
import { getUsers } from '../../../Services/Users/action';
import { connect } from 'react-redux';
import { generateSalarySlip, userdetailsSalarySlip } from '../../../Services/Salary/action';
import { toast } from 'react-toastify';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { MdOutlineRemoveCircleOutline } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { getLeaves } from '../../../Services/Leave/action';
import { Month, Year } from '../../../Lib/utils';
import Select from 'react-select';
import { customStyle } from '../../../Components/Style';
import Skeleton from 'react-loading-skeleton';
import moment from 'moment';

function GenerateSalarySlip(props) {
    const [payMonth, setPayMonth] = useState(null);
    const [payYear, setPayYear] = useState(null);
    const [payDate, setPayDate] = useState(new Date());
    const [users, setUsers] = useState([]);
    const [salaryData, setSalaryData] = useState({});
    const [days, setDays] = useState('');
    const [selectedUsers, setSelectedUsers] = useState(new Set());
    const [selectAll, setSelectAll] = useState(false);
    const navigate = useNavigate();

    const unpaidLeaveSum = (props.leave || [])
        .filter(leave => {
            const leaveStart = moment(leave.start_date).format('MMMM YYYY');
            const leaveEnd = moment(leave.end_date).format('MMMM YYYY');
            return leaveStart === `${payMonth?.value} ${payYear?.value}` && leaveEnd === `${payMonth?.value} ${payYear?.value}`;
        })
        .reduce((sum, leave) => sum + (Number(leave.unpaid) || 0), 0);

    const earningFields = [
        { label: "Basic Salary", name: "basic_salary" },
        { label: "House Rent Allowance", name: "house_rent_allowance" },
        { label: "DA", name: "da" },
        { label: "MA", name: "ma" },
        { label: "Special Allowance", name: "special_allowance" }
    ];

    const deductionFields = [
        { label: "Income Tax", name: "incomeTax" },
        { label: "Provident Fund", name: "providentFund" }
    ];

    useEffect(() => {
        props.userdetailsSalarySlip();
        props.getLeaves();
    }, []);

    useEffect(() => {
        if (props.salary?.length) {
            const processedUsers = props.salary.map(user => ({
                ...user,
                originalSalary: user.salary,
                unpaid_leave: unpaidLeaveSum || 0
            }));
            setUsers(processedUsers);

            const initialFormData = processedUsers.reduce((acc, user) => ({
                ...acc,
                [user.id]: {
                    earnings: {
                        basic_salary: 0,
                        house_rent_allowance: 0,
                        da: 0,
                        ma: 0,
                        special_allowance: 0
                    },
                    deductions: {
                        incomeTax: 0,
                        providentFund: 0
                    },
                    extraEarnings: [],
                    extraDeductions: [],
                    transactionId: '',
                    lossdays: user.unpaid_leave || 0
                }
            }), {});
            setSalaryData(initialFormData);
        }
    }, [props?.salary, unpaidLeaveSum]);

    useEffect(() => {
        if (!users.length || !days || Number(days) <= 0) return;

        const workingDays = Number(days);
        const updatedUsers = users.map(user => {
            const oneDaySalary = user.originalSalary / workingDays;
            const currentLossdays = salaryData[user.id]?.lossdays || user.unpaid_leave || 0;
            const leaveDeduction = currentLossdays * oneDaySalary;
            const finalSalary = user.originalSalary - leaveDeduction;

            return {
                ...user,
                oneDaySalary,
                leaveDeduction,
                salary: Math.max(0, finalSalary),
                currentLossdays
            };
        });
        setUsers(updatedUsers);
    }, [days, props.salary]);

    useEffect(() => {
        if (!users.length || !days || Number(days) <= 0) return;

        const workingDays = Number(days);
        const updatedUsers = users.map(user => {
            const oneDaySalary = user.originalSalary / workingDays;
            const currentLossdays = salaryData[user.id]?.lossdays || user.unpaid_leave || 0;
            const leaveDeduction = currentLossdays * oneDaySalary;
            const finalSalary = user.originalSalary - leaveDeduction;

            return {
                ...user,
                oneDaySalary,
                leaveDeduction,
                salary: Math.max(0, finalSalary),
                currentLossdays
            };
        });
        setUsers(updatedUsers);
    }, [Object.values(salaryData).map(data => data.lossdays).join(','), days, props.salary]);

    useEffect(() => {
        if (!users.length || !days) return;

        const updatedSalaryData = { ...salaryData };

        users.forEach(user => {
            if (user.salary > 0) {
                const adjustedSalary = Math.max(0, user.salary - 1250);
                const maAmount = Math.min(1250, user.salary);

                const breakdown = {
                    basic_salary: Math.round(adjustedSalary * 0.4),
                    house_rent_allowance: Math.round(adjustedSalary * 0.2),
                    da: Math.round(adjustedSalary * 0.1),
                    ma: maAmount,
                    special_allowance: Math.round(adjustedSalary * 0.3),
                };

                if (updatedSalaryData[user.id]) {
                    updatedSalaryData[user.id] = {
                        ...updatedSalaryData[user.id],
                        earnings: {
                            ...updatedSalaryData[user.id].earnings,
                            ...breakdown
                        },
                        lossdays: updatedSalaryData[user.id].lossdays || user.unpaid_leave || 0
                    };
                }
            }
        });

        setSalaryData(updatedSalaryData);
    }, [users, days]);

    const calculateTotals = (userId) => {
        const userData = salaryData[userId] || {};
        const earnings = userData.earnings || {};
        const deductions = userData.deductions || {};
        const extraEarnings = userData.extraEarnings || [];
        const extraDeductions = userData.extraDeductions || [];

        const totalEarnings = Object.values(earnings).reduce((sum, val) => sum + (Number(val) || 0), 0) +
            extraEarnings.reduce((sum, field) => sum + (Number(field.value) || 0), 0);

        const totalDeductions = Object.values(deductions).reduce((sum, val) => sum + (Number(val) || 0), 0) +
            extraDeductions.reduce((sum, field) => sum + (Number(field.value) || 0), 0);

        const netTotal = totalEarnings - totalDeductions;

        return { totalEarnings, totalDeductions, netTotal };
    };

    const handleChange = (userId, section, name, value) => {
        const numValue = value === '' ? 0 : Number(value);
        if (numValue < 0) return;

        setSalaryData((prev) => ({
            ...prev,
            [userId]: {
                ...prev[userId],
                [section]: {
                    ...prev[userId][section],
                    [name]: numValue
                }
            }
        }));
    };

    const handleUserFieldChange = (userId, field, value) => {
        setSalaryData((prev) => ({
            ...prev,
            [userId]: {
                ...prev[userId],
                [field]: value
            }
        }));
    };

    const handleExtraChange = (userId, section, index, key, value) => {
        const updatedFields = [...(salaryData[userId][section] || [])];
        if (updatedFields[index]) {
            updatedFields[index][key] = key === 'value' ? (Number(value) || 0) : value;
        }

        setSalaryData((prev) => ({
            ...prev,
            [userId]: {
                ...prev[userId],
                [section]: updatedFields
            }
        }));
    };

    const handleAddField = (userId, section) => {
        setSalaryData((prev) => ({
            ...prev,
            [userId]: {
                ...prev[userId],
                [section]: [...(prev[userId][section] || []), { name: '', value: 0 }]
            }
        }));
    };

    const handleRemoveField = (userId, section, index) => {
        const updatedFields = [...(salaryData[userId][section] || [])];
        updatedFields.splice(index, 1);
        setSalaryData((prev) => ({
            ...prev,
            [userId]: {
                ...prev[userId],
                [section]: updatedFields
            }
        }));
    };

    const handleUserSelection = (userId, isChecked) => {
        const newSelectedUsers = new Set(selectedUsers);
        if (isChecked) {
            newSelectedUsers.add(userId);
        } else {
            newSelectedUsers.delete(userId);
        }
        setSelectedUsers(newSelectedUsers);
        setSelectAll(newSelectedUsers.size === users.length);
    };

    const handleSelectAll = (isChecked) => {
        setSelectAll(isChecked);
        if (isChecked) {
            setSelectedUsers(new Set(users.map(user => user.id)));
        } else {
            setSelectedUsers(new Set());
        }
    };

    const validateUserData = (userId) => {
        const userData = salaryData[userId];
        const user = users.find(u => u.id === userId);

        if (!userData || !userData.earnings || !userData.earnings.basic_salary) {
            return `Basic Salary is required for ${user?.name || 'Unknown User'}`;
        }
        return null;
    };

    const handleSubmit = async () => {
        if (selectedUsers.size === 0) {
            toast.error('Please select at least one user.');
            return;
        }

        if (!days || Number(days) <= 0) {
            toast.error('Valid Working Days field is required.');
            return;
        }

        if (!payMonth || !payYear) {
            toast.error('Pay Period Month and Year fields are required.');
            return;
        }

        for (const userId of selectedUsers) {
            const validationError = validateUserData(userId);
            if (validationError) {
                toast.error(validationError);
                return;
            }
        }

        try {
            const selectedUsersList = Array.from(selectedUsers);

            const usersData = selectedUsersList.map(userId => {
                const userData = salaryData[userId];
                const user = users.find(u => u.id === userId);

                if (!userData || !user) {
                    throw new Error(`User data not found for ID: ${userId}`);
                }

                const earnings = {
                    ...userData.earnings,
                    ...(userData.extraEarnings || []).reduce((acc, curr) => ({
                        ...acc,
                        [curr.name]: curr.value || 0
                    }), {})
                };

                const deductions = {
                    ...userData.deductions,
                    ...(userData.extraDeductions || []).reduce((acc, curr) => ({
                        ...acc,
                        [curr.name]: curr.value || 0
                    }), {})
                };

                const totalEarnings = Object.values(earnings).reduce((sum, val) => sum + (Number(val) || 0), 0);
                const totalDeductions = Object.values(deductions).reduce((sum, val) => sum + (Number(val) || 0), 0);
                const totalPay = totalEarnings - totalDeductions;

                return {
                    userId,
                    name: user.name,
                    employee_id: userId,
                    total_pay: totalPay,
                    transaction_id: userData.transactionId || '',
                    loss_pay_day: Number(userData.lossdays) || 0,
                    salary_details: [{
                        earning: earnings,
                        deduction: deductions
                    }]
                };
            });

            const payPeriodMonthAndYear = `${payMonth.value} ${payYear.value}`;
            const payload = {
                users: usersData,
                pay_period: payPeriodMonthAndYear,
                pay_date: payDate,
                day: Number(days),
                is_multiple: selectedUsersList.length > 1
            };

            const response = await props.generateSalarySlip(payload);
            if (response.status === 200) {
                toast.success(`Salary slip${selectedUsersList.length > 1 ? 's' : ''} generated successfully!`);

                setSelectedUsers(new Set());
                setSelectAll(false);

                setSalaryData(prev => {
                    const updated = { ...prev };
                    selectedUsersList.forEach(userId => {
                        if (updated[userId]) {
                            updated[userId] = {
                                ...updated[userId],
                                transactionId: '',
                                lossdays: 0
                            };
                        }
                    });
                    return updated;
                });

            } else if (response.status === 409) {
                toast.error(response.message || 'Conflict occurred while generating salary slip.');
            } else {
                toast.error('Failed to generate salary slip. Please try again.');
            }

        } catch (err) {
            console.error('Error generating salary slip:', err);
            toast.error('Failed to generate salary slip. Please try again.');
        }
    };

    return (
        <div>
            <div className='d-flex justify-content-between align-items-center'>
                <h5 className="mb-4 mt-4">
                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width={200} height={40} />
                        ) : (
                            "Generate Salary Slip"
                        )
                    }
                </h5>
                <div className="edit-btn">
                    {
                        props.loading ? (
                            <Skeleton className='badge rounded-pill' width={100} height={40} />
                        ) : (
                            <button
                                type="button"
                                className="custom-btn"
                                onClick={() => navigate(-1)}
                            >
                                Cancel
                            </button>
                        )
                    }
                </div>
            </div>

            <div className="mb-4">
                <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">
                        {
                            props.loading ? (
                                <Skeleton className='rounded-2' width={150} height={40} />
                            ) : (
                                "Pay Period:"
                            )
                        }
                    </label>
                    <div className="col-sm-8 d-flex align-items-center gap-2">
                        <div>
                            {
                                props.loading ? (
                                    <Skeleton className='rounded-2' width="100%" height={40} />
                                ) : (
                                    <Select
                                        styles={customStyle}
                                        placeholder="Select Month"
                                        value={payMonth}
                                        options={Month}
                                        onChange={(selectedOption) => setPayMonth(selectedOption)}
                                    />
                                )
                            }
                        </div>
                        <div>
                            {
                                props.loading ? (
                                    <Skeleton className='rounded-2' width="100%" height={40} />
                                ) : (
                                    <Select
                                        styles={customStyle}
                                        placeholder="Select Year"
                                        value={payYear}
                                        options={Year}
                                        onChange={(selectedOption) => setPayYear(selectedOption)}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>

                <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">
                        {
                            props.loading ? (
                                <Skeleton className='rounded-2' width={150} height={40} />
                            ) : (
                                "Pay Date:"
                            )
                        }
                    </label>
                    <div className="col-sm-4">
                        {
                            props.loading ? (
                                <Skeleton className='rounded-2' width="100%" height={40} />
                            ) : (
                                <DatePicker
                                    selected={payDate}
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    onChange={(date) => setPayDate(date)}
                                    placeholderText="Select Pay Date"
                                    showTimeSelect={false}
                                />
                            )
                        }
                    </div>
                </div>

                <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">
                        {
                            props.loading ? (
                                <Skeleton className='rounded-2' width={150} height={40} />
                            ) : (
                                "Working Days:"
                            )
                        }
                    </label>
                    <div className="col-sm-4">
                        {
                            props.loading ? (
                                <Skeleton className='rounded-2' width="100%" height={40} />
                            ) : (
                                <input
                                    type="number"
                                    className="form-control"
                                    min="1"
                                    max="31"
                                    value={days}
                                    onChange={(e) => setDays(e.target.value)}
                                    placeholder="Enter Working Days"
                                />
                            )
                        }
                    </div>
                </div>
            </div>

            <div className="mb-3">
                {
                    props.loading ? (
                        <Skeleton className='rounded-2' width="100%" height={40} />
                    ) : (
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="selectAll"
                                checked={selectAll}
                                onChange={(e) => handleSelectAll(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="selectAll">
                                Select All Users ({selectedUsers.size}/{users.length} selected)
                            </label>
                        </div>
                    )
                }
            </div>

            {
                props.loading ? (
                    <Skeleton className='rounded-2' count={5} width="100%" height={40} />
                ) : (
                    <Accordion defaultActiveKey="0">
                        {users.map((item, index) => {
                            const { totalEarnings, totalDeductions, netTotal } = calculateTotals(item.id);
                            return (
                                <Accordion.Item key={item.id} eventKey={index.toString()}>
                                    <Accordion.Header>
                                        <div className='d-flex justify-content-between w-100'>
                                            <div className='d-flex justify-content-center align-items-center gap-2'>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedUsers.has(item.id)}
                                                    onChange={(e) => handleUserSelection(item.id, e.target.checked)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={{ height: "16px", width: "16px" }}
                                                />
                                                <span className={selectedUsers.has(item.id) ? 'fw-bold text-primary' : ''}>
                                                    {item.name}
                                                </span>
                                            </div>
                                            <div className='me-4'>
                                                Net Total: ₹{netTotal.toFixed(2)} (Earnings: ₹{totalEarnings.toFixed(2)} - Deductions: ₹{totalDeductions.toFixed(2)})
                                            </div>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="row mb-3">
                                            <div className="row m-0 col-md-6">
                                                <label className="col-sm-4 col-form-label">Transaction Id:</label>
                                                <div className="col-sm-8">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={salaryData[item.id]?.transactionId || ''}
                                                        onChange={(e) => handleUserFieldChange(item.id, 'transactionId', e.target.value)}
                                                        placeholder="Transaction Id"
                                                    />
                                                </div>
                                            </div>
                                            <div className="row m-0 col-md-6">
                                                <label className="col-sm-4 col-form-label">Loss of Pay Days:</label>
                                                <div className="col-sm-8">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        min="0"
                                                        value={salaryData[item.id]?.lossdays || 0}
                                                        onChange={(e) => handleUserFieldChange(item.id, 'lossdays', e.target.value)}
                                                        placeholder="Enter Loss of Pay Days"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <h5 className="mb-2">Earnings</h5>
                                                <table className="table">
                                                    <tbody>
                                                        {earningFields.map((field) => (
                                                            <tr key={field.name}>
                                                                <td>{field.label}</td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        name={field.name}
                                                                        className="form-control"
                                                                        value={salaryData[item.id]?.earnings?.[field.name] || 0}
                                                                        placeholder={`Enter ${field.label}`}
                                                                        onChange={(e) =>
                                                                            handleChange(item.id, 'earnings', field.name, e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {salaryData[item.id]?.extraEarnings?.map((field, i) => (
                                                            <tr key={i}>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Field Name"
                                                                        value={field.name || ''}
                                                                        onChange={(e) =>
                                                                            handleExtraChange(item.id, 'extraEarnings', i, 'name', e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Amount"
                                                                        value={field.value || 0}
                                                                        onChange={(e) =>
                                                                            handleExtraChange(item.id, 'extraEarnings', i, 'value', e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm text-danger"
                                                                        onClick={() => handleRemoveField(item.id, 'extraEarnings', i)}
                                                                    >
                                                                        <MdOutlineRemoveCircleOutline size={20} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                <button
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={() => handleAddField(item.id, 'extraEarnings')}
                                                >
                                                    <IoMdAddCircleOutline size={18} /> Add Earning Field
                                                </button>
                                            </div>

                                            <div className="col-md-6">
                                                <h5 className="mb-2">Deductions</h5>
                                                <table className="table">
                                                    <tbody>
                                                        {deductionFields.map((field) => (
                                                            <tr key={field.name}>
                                                                <td>{field.label}</td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        name={field.name}
                                                                        className="form-control"
                                                                        placeholder={`Enter ${field.label}`}
                                                                        value={salaryData[item.id]?.deductions?.[field.name] || 0}
                                                                        onChange={(e) =>
                                                                            handleChange(item.id, 'deductions', field.name, e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {salaryData[item.id]?.extraDeductions?.map((field, i) => (
                                                            <tr key={i}>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Field Name"
                                                                        value={field.name || ''}
                                                                        onChange={(e) =>
                                                                            handleExtraChange(item.id, 'extraDeductions', i, 'name', e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Amount"
                                                                        value={field.value || 0}
                                                                        onChange={(e) =>
                                                                            handleExtraChange(item.id, 'extraDeductions', i, 'value', e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm text-danger"
                                                                        onClick={() => handleRemoveField(item.id, 'extraDeductions', i)}
                                                                    >
                                                                        <MdOutlineRemoveCircleOutline size={20} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                <button
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={() => handleAddField(item.id, 'extraDeductions')}
                                                >
                                                    <IoMdAddCircleOutline size={18} /> Add Deduction Field
                                                </button>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            );
                        })}
                    </Accordion>
                )
            }

            {
                selectedUsers.size > 0 && (
                    <div className="mt-4 d-flex justify-content-center">
                        {
                            props.loading ? (
                                <Skeleton className='badge rounded-pill' width={200} height={40} />
                            ) : (
                                <button
                                    className="btn btn-primary mb-5"
                                    onClick={handleSubmit}
                                >
                                    Generate Salary Slip{selectedUsers.size > 1 ? 's' : ''}
                                    {selectedUsers.size > 0 && ` (${selectedUsers.size} user${selectedUsers.size > 1 ? 's' : ''})`}
                                </button>
                            )
                        }
                    </div>
                )
            }
        </div >
    );
}

const mapStateToProps = (state) => ({
    loading: state.bankdetailsReducer.loading,
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    users: state.userReducer.users,
    salary: state.salaryReducer.salary,
    leave: state.leaveReducer.leave
});

const mapDispatchToProps = (dispatch) => ({
    generateSalarySlip: (options) => dispatch(generateSalarySlip(options)),
    userdetailsSalarySlip: () => dispatch(userdetailsSalarySlip()),
    getLeaves: () => {
        dispatch(getLeaves())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(GenerateSalarySlip);